import React, { useEffect } from "react";
import "./HeroComponent.scss";
import { EonUiButton } from "@eon-ui/eon-ui-components-react";
import { useTranslation } from "@me8eon/translation";
import { useTranslation as useTranslationNative } from "react-i18next";
import { useLanguage } from "@me8eon/language";
import { useNavigate, useLocation } from "react-router-dom";
import { app } from "@microsoft/teams-js";
import { authenticateDebugName, useLogin, useUserData } from "@me8eon/react_authentication";
import { useDebug } from "@me8eon/debug";
import { takeSharedLinkAfterLogin } from "../../pages/ai/sharedLinkLogin";

export const HeroComponent: React.FC = () => {
    const { t } = useTranslation();
    const { i18n } = useTranslationNative();
    const [language, setLanguage] = useLanguage();
    const location = useLocation();
    const navigate = useNavigate();
    const debug = useDebug(authenticateDebugName);
    const { login: handleLogin } = useLogin();
    const { loggedIn } = useUserData();

    useEffect(() => {
        const newLang = i18n.resolvedLanguage || "en";
        localStorage.setItem("i18nextLng", newLang);
        setLanguage(newLang);

        if (loggedIn) {
            // A shared-chat link opened while signed out survives the login
            // redirect only through sessionStorage; see sharedLinkLogin.ts.
            const from = takeSharedLinkAfterLogin() ?? (location.state?.from?.pathname || '/ai');
            navigate(from, { replace: true, state: {} });
        }
        (async () => {
            try {
                console.log("Initialising App");
                await app.initialize();
                console.log("App Initialised");
                const context = await app.getContext();
                if (context) {
                    // await authoriseTeamsUser(ssoLogin); //TODO Need to do this with new authentication
                }
            } catch (err) {
                console.log(err);
            }
        })();
    }, [loggedIn]);

    return (
        <div className="hero-wrapper" data-testid="heroComponent">
            <div className="content-wrapper">
                <div className="welcome-content">
                    <div className="heading me8eon">{t("headerData1")}</div>
                    <div className="subheading">{t("headerData2")}</div>
                    <div className="hint"><span className="hint-text" dangerouslySetInnerHTML={{ __html: t("headerMessage") }}></span></div>
                    <div className="login-form">
                        <div className="login-button-align">
                            <EonUiButton
                                id="enableLogin"
                                className="login-button-between-space-tab-laptop"
                                onClick={() => handleLogin(debug)}
                                text={t("loginLable")}
                                fullWidthOnMobile={true}
                                size="small"
                            ></EonUiButton>
                        </div>
                        <p></p>
                    </div>
                </div>
            </div>
        </div>
    );
};
